import type { ReactNode } from 'react';

import type { IconName } from '@/icons/icon-list';
import type { SpaceRoles, UserFeatures, UserRoles } from '@/services/firebaseServices/AuthServices/types';
import type { SpaceListItem, SpacesListServiceConfig } from '@/services/httpServices/SpacesServices/types';

// ------------- NAVIGATION ENUMS -------------

export enum NavigationSection {
  TRAINING = 'training',
  CONTENT = 'content',
  ADMIN = 'admin',
}

export enum NavigationItemId {
  CERTIFICATES = 'certificates',
  PROFILES = 'profiles',
  JOB_PROFILES = 'jobProfiles',
  SKILL_MATRIX = 'skillMatrix',
  COURSES = 'courses',
  SEQUENCES = 'sequences',
  QUIZZES = 'quizzes',
  GALLERY = 'gallery',
  GLOSSARY = 'glossary',
  ABTESTS = 'abtests',
}

// ------------- NAVIGATION TYPES -------------

export type NavigationItem = {
  id: NavigationItemId;
  section: NavigationSection;
  titleKey: string;
  url: string;
  icon: IconName;
  /**
   * Features required to access this navigation item.
   * User must have at least one of these features.
   */
  requiredFeatures: UserFeatures[];
};

export type NavigationPermissions = {
  role: UserRoles | SpaceRoles | null;
  features: UserFeatures[];
};

export type NavigationConfig = {
  [NavigationSection.TRAINING]: NavigationItem[];
  [NavigationSection.CONTENT]: NavigationItem[];
  [NavigationSection.ADMIN]: NavigationItem[];
};

// ------------- COMPONENT PROPS -------------

export type SidebarProps = {
  children: ReactNode;
  currentSpaceId?: string;
  spacesQueryConfig: SpacesListServiceConfig;
  userEmail?: string;
  userName?: string;
  userRole: string | null;
  userFeatures: UserFeatures[];
  userSpacesFromClaims?: SpaceListItem[];
  isIframe?: boolean;
  /** Space code for trainer app login - prefetched on server */
  spaceCode?: string;
  /** Whether the layout is ready for animations (after hydration) */
  isLayoutReady?: boolean;
};

// Re-export space types for convenience
export type { SpaceListItem };
